module.exports = "/_next/static/resources/life2-5468d55788bdc172b9aabc2ce49e4939.jpg";